import {
	ClientPortfolioToolIdentificationTypeEnum,
	ClientPortfolioToolTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { ToolKind } from "web_myplann/Portfolio/Helpers/investmentToolTypes";

export const EXCLUDED_IDENTIFICATION_TYPES = [
	ClientPortfolioToolIdentificationTypeEnum.Crypto,
	ClientPortfolioToolIdentificationTypeEnum.Null,
	ClientPortfolioToolIdentificationTypeEnum.BankProduct,
	ClientPortfolioToolIdentificationTypeEnum.None,
] as const;

export const isFundLikeToolType = (type: ClientPortfolioToolTypeEnum | null) =>
	type !== ClientPortfolioToolTypeEnum.Commodity &&
	type !== ClientPortfolioToolTypeEnum.Crypto &&
	type !== ClientPortfolioToolTypeEnum.BankProduct;

type ToolKindSource = {
	type: ClientPortfolioToolTypeEnum | null;
	isAdvisorBond: boolean;
};

export const getInvestmentToolKind = ({
	type,
	isAdvisorBond,
}: ToolKindSource): ToolKind => {
	if (isAdvisorBond) {
		return ToolKind.Bond;
	}
	switch (type) {
		case ClientPortfolioToolTypeEnum.Commodity:
			return ToolKind.Commodity;
		case ClientPortfolioToolTypeEnum.Crypto:
			return ToolKind.Crypto;
		case ClientPortfolioToolTypeEnum.BankProduct:
			return ToolKind.BankProduct;
		default:
			return ToolKind.Investment;
	}
};
